export { default } from './NonBrandedEndpageHeader';
export type { Props as NonBrandedEndpageHeaderProps } from './NonBrandedEndpageHeader';
